<template>
  <div>
    <div class="tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-2 tw:lg:grid-cols-3">
      <template v-for="tmpl in templates" :key="tmpl.value">
        <label class="tw:block tw:cursor-pointer">
          <input
            type="radio"
            name="template"
            v-model="selectedTemplate"
            :value="tmpl.value"
            class="tw:sr-only"
          >
          <div :class="['tw:h-full tw:rounded-lg tw:border tw:bg-white tw:p-4 tw:transition-colors', selectedTemplate === tmpl.value ? 'tw:border-primary tw:ring-1 tw:ring-primary' : 'tw:border-zinc-200 hover:tw:border-zinc-400']">
            <div class="tw:flex tw:items-center tw:gap-3">
              <div class="tw:flex-1">
                <p class="tw:mb-0 tw:font-semibold">{{ tmpl.label }}</p>
                <small class="tw:text-zinc-500">{{ tmpl.description }}</small>
              </div>
            </div>
          </div>
        </label>
      </template>
    </div>

    <div class="tw:mt-4">
      <template v-if="loading">
        <div class="tw:flex tw:h-48 tw:items-center tw:justify-center">
          <div class="tw:size-8 tw:animate-spin tw:rounded-full tw:border-4 tw:border-zinc-200 tw:border-t-primary" role="status">
            <span class="tw:sr-only">{{ $t('Loading…') }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <iframe
          :srcdoc="previewSrcdoc"
          :style="{ height: frameHeight, width: frameWidth }"
          class="tw:rounded-lg tw:border-0 tw:shadow-sm"
        ></iframe>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';

const props = defineProps({
  templates: {
    type: Array,
    required: true,
  },
  currentTemplate: {
    type: String,
    required: true,
  },
  previewUrl: {
    type: String,
    required: true,
  },
  frameHeight: {
    type: String,
    default: '800px',
  },
  frameWidth: {
    type: String,
    default: '100%',
  },
});

const selectedTemplate = ref(props.currentTemplate);
const previewSrcdoc = ref('');
const loading = ref(false);

const fetchPreview = async () => {
  loading.value = true;
  try {
    const separator = props.previewUrl.includes('?') ? '&' : '?';
    const url = `${props.previewUrl}${separator}template=${encodeURIComponent(selectedTemplate.value)}`;
    const response = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    previewSrcdoc.value = await response.text();
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

watch(selectedTemplate, fetchPreview);

onMounted(fetchPreview);
</script>

<style scoped>
</style>
